module.exports = __webpack_public_path__ + "static/media/mosque.f08e0f21.svg";